import api from "../api";

class ProtheusAPI {
  async IncluirPedidoLojaDrp(headers, params) {
    const response = await api({
      method: 'post',
      url: '/incluir_pedido_loja_drp_protheus',
      headers,
      data: params
    })

    return response
  }

  async getStatusExportacaoProtheus(headers, params) {
    const response = await api.get("/get_status_exportacao_protheus", {headers, params});

    return response
  }
}

export default new ProtheusAPI();
